import { Book } from 'types';
import { pluralize } from 'sdk';

import Callout from '../../callout';
import CartFilledSVG from '~/assets/svg/icons/cart-filled';
import styles from '../../../styles/components/callout.module.scss';
import COLORS from '~/lib/helpers/color-helper';
import { useGlobalState } from '~/state';

export default function CartCallout({ book, disabled }: { book: Book; disabled?: boolean }) {
  const { state } = useGlobalState();
  function shouldShowForSeller() {
    return state.user.data?.uid === book.seller_id && book.cart_count && book.cart_count >= 1;
  }

  if ((!book.cart_count || book.cart_count < 2 || disabled) && !shouldShowForSeller()) return null;

  return (
    <Callout
      small
      inline
      title='There are eyes on this.'
      message={`${book.cart_count} ${pluralize('person', book.cart_count as number)} ${
        book.cart_count === 1 ? 'has' : 'have'
      } this book in their cart.`}
      icon={<CartFilledSVG fillColor={COLORS.green} />}
      containerStyles={styles['no-padding']}
    />
  );
}
